const prodUrl = import.meta.env.VITE_API_URL || 'https://api.app.homolog.teceo.co';
const localUrl = import.meta.env.VITE_API_URL || 'http://localhost:3030';

const wsProdUrl = import.meta.env.VITE_WS_URL || 'wss://api.app.homolog.teceo.co';
const wsLocalUrl = import.meta.env.VITE_WS_URL || 'http://localhost:3030';

const wsChatProdUrl = import.meta.env.VITE_WS_URL || 'wss://api.app.homolog.teceo.co';
const wsChatLocalUrl = import.meta.env.VITE_WS_CHAT_URL || 'http://localhost:3039';

const prodDropBoxOAuthUrl = 'https://www.dropbox.com/oauth2';
const localDropBoxOAuthUrl = 'https://www.dropbox.com/oauth2';

const prodInstagramOAuthUrl = 'https://api.instagram.com/oauth';
const localInstagramOAuthUrl = 'https://api.instagram.com/oauth';

const prodDropBoxClientId = 'oo0ev87m753tt6s';
const localDropBoxClientId = 'oo0ev87m753tt6s';

const prodInstagramClientId = '303607481128281';
const localInstagramClientId = '303607481128281';

const localIntegrationClientUrl = 'http://localhost:3037';
const prodIntegrationClientUrl = 'http://linx-client:3037';

const apmURL = 'https://apm.teceo.co';

const config = {
  baseURL: import.meta.env.PROD ? prodUrl : localUrl,
  websocketUrl: import.meta.env.PROD ? wsProdUrl : wsLocalUrl,
  websocketChatUrl: import.meta.env.PROD ? wsChatProdUrl : wsChatLocalUrl,
  dropBoxOAuthUrl: import.meta.env.PROD ? prodDropBoxOAuthUrl : localDropBoxOAuthUrl,
  dropBoxClientId: import.meta.env.PROD ? prodDropBoxClientId : localDropBoxClientId,
  instagramClientId: import.meta.env.PROD ? prodInstagramClientId : localInstagramClientId,
  instagramOAuthUrl: import.meta.env.PROD ? prodInstagramOAuthUrl : localInstagramOAuthUrl,
  webUrl: window.location.origin,
  integrationClientUrl: import.meta.env.PROD ? prodIntegrationClientUrl : localIntegrationClientUrl,
  clarityProjectId: import.meta.env.VITE_CLARITY_PROJECT_ID,
  apmURL,
  offline: {
    encryption: {
      counterValue: parseInt(import.meta.env.VITE_OFFLINE_ENCRYPTION_COUNTER_VALUE) || 1,
    },
  },
};

export default config;
